import { fetchUtils } from '$utils/fetchUtils'
import { mmpvState } from '$lib/mmpv/mmpv.state.svelte'
import type { QuantityUnit } from '$lib/mmpv/types/quantity'
import { DefaultNotification, NotificationType } from '$types/notification'
import { addNotification } from '$lib/stores'
import { get } from 'svelte/store'
import { t } from '$i18n/i18n'

export async function fetchQuantities(): Promise<void> {
	await fetchUtils
		.get('/api/quantities')
		.then((data: QuantityUnit[]) => {
			mmpvState.quantities = [...(data ?? [])]
		})
		.catch(fetchUtils.catchErrorAndShowNotification())
}

export async function updateQuantity(unit: QuantityUnit): Promise<QuantityUnit | void> {
	return fetchUtils
		.post(`/api/quantities/update`, unit)
		.then((data: QuantityUnit) => {
			const previousUnit = mmpvState.quantities.find((q) => q.publicId === data.publicId)
			// eslint-disable-next-line svelte/prefer-svelte-reactivity
			const removedNodeIds = new Set(
				(previousUnit?.materialNodeIds ?? []).filter(
					(id) => !(data.materialNodeIds ?? []).includes(id)
				)
			)
			// eslint-disable-next-line svelte/prefer-svelte-reactivity
			const assignedNodeIds = new Set(data.materialNodeIds ?? [])

			mmpvState.quantities = mmpvState.quantities.some((q) => q.publicId === data.publicId)
				? mmpvState.quantities.map((q) => (q.publicId === data.publicId ? data : q))
				: [...mmpvState.quantities, data]

			for (const catalog of mmpvState.catalogs) {
				for (const node of catalog.nodes ?? []) {
					if (assignedNodeIds.has(node.id)) {
						node.quantityId = data.publicId
					} else if (removedNodeIds.has(node.id)) {
						node.quantityId = undefined
					}
				}
			}

			addNotification(
				DefaultNotification(
					get(t)('UI.mmpv.quantities.updated.notification.success'),
					NotificationType.SUCCESS,
					false,
					3500,
					'modal'
				)
			)
			return data
		})
		.catch(fetchUtils.catchErrorAndShowNotification('modal'))
}

export async function deleteQuantity(unit: QuantityUnit): Promise<void> {
	return fetchUtils
		.post(`/api/quantities/delete/${unit.publicId}`, unit)
		.then(() => {
			mmpvState.quantities = mmpvState.quantities.filter(
				(quantity) => quantity.publicId !== unit.publicId
			)

			// eslint-disable-next-line svelte/prefer-svelte-reactivity
			const orphanedNodeIds = new Set(unit.materialNodeIds ?? [])
			for (const catalog of mmpvState.catalogs) {
				for (const node of catalog.nodes ?? []) {
					if (orphanedNodeIds.has(node.id)) {
						node.quantityId = undefined
					}
				}
			}
			addNotification(
				DefaultNotification(
					get(t)('UI.mmpv.quantities.deleted.notification.success'),
					NotificationType.SUCCESS,
					true,
					undefined,
					'modal'
				)
			)
		})
		.catch(fetchUtils.catchErrorAndShowNotification('modal'))
}
